// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifospay.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.http.HttpMethod
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.Boolean
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kotlin.collections.List
import org.mifospay.core.network.model.entity.SearchedEntity

@OptIn(InternalKtorfitApi::class)
public class _SearchServiceImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : SearchService {
  override suspend fun searchResources(
    query: String,
    resources: String,
    exactMatch: Boolean,
  ): List<SearchedEntity> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "search")
        query?.let{ parameter("query", "$it") }
        resources?.let{ parameter("resource", "$it") }
        exactMatch?.let{ parameter("exactMatch", "$it") }
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<List<SearchedEntity>>(),)!! 
  }
}

public class _SearchServiceProvider : ClassProvider<SearchService> {
  override fun create(_ktorfit: Ktorfit): SearchService = _SearchServiceImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

public fun Ktorfit.createSearchService(): SearchService = _SearchServiceImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
